import axios from 'axios';

export const API_BASE_URL = 'https://tunisie-telecom.cap.tn/api';

export const BACKEND_URL = API_BASE_URL.replace('/api', '');

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('userToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('userToken');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('lastActiveAt');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default axiosClient;